import { Text, View } from "@react-pdf/renderer";
import React from "react";
import { borderStyleGray } from "../reportingHelpers";

const cellStyle = {
  border: borderStyleGray,
  borderLeft: "unset",
  borderTop: "unset",
  alignItems: "center",
};

const TeamCardsHeader = ({ intl }) => (
  <View
    style={{
      flexDirection: "row",
      fontSize: 10,
      fontWeight: "bold",
      width: "100%",
    }}
  >
    <View style={{ ...cellStyle, flexBasis: "10%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.cardsReport.card",
          defaultMessage: "Card",
        })}
      </Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "10%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.minute",
          defaultMessage: "Minute",
        })}
      </Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "10%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.matchReport.shirtNumber",
          defaultMessage: "Shirt #",
        })}
      </Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "25%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.cardsReport.player",
          defaultMessage: "Player",
        })}
      </Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "25%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.cardsReport.reason",
          defaultMessage: "Reason",
        })}
      </Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "10%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.cardsReport.duration",
          defaultMessage: "Duration*",
        })}
      </Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "10%" }}>
      <Text>
        {intl.formatMessage({
          id: "reports.cardsReport.checked",
          defaultMessage: "Checked",
        })}
      </Text>
    </View>
  </View>
);

const getCardColor = (cardType) => {
  if (cardType === "greenCard") return "#006300";
  if (cardType === "yellowCard") return "#FBFB02";
  if (cardType === "redCard") return "#FF2500";
  return "#FFFFFF";
};

const CardDetailRow = ({ duration, intl, minute, player, reason, type }) => (
  <View style={{ flexDirection: "row", width: "100%" }}>
    <View
      style={{
        ...cellStyle,
        flexBasis: "10%",
        backgroundColor: getCardColor(type),
        color: type === "yellowCard" ? "black" : "white",
      }}
    >
      <Text style={{ textTransform: "uppercase" }}>
        {intl.formatMessage({
          id: `reports.cardsReport.${type}`,
          defaultMessage: "Card",
        })}
      </Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "10%" }}>
      <Text>{minute}</Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "10%" }}>
      <Text>{player?.bib}</Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "25%" }}>
      <Text>{player?.personFullName}</Text>
    </View>
    <View style={{ ...cellStyle, flexBasis: "25%" }}>
      <Text>
        {reason
          ? intl.formatMessage({
              id: `reports.cardsReport.reason.${reason}`,
              defaultMessage: "Card reason",
            })
          : ""}
      </Text>
    </View>
    {type === "redCard" ? (
      <View
        style={{
          ...cellStyle,
          flexBasis: "10%",
          backgroundColor: "#FF2500",
          color: "white",
        }}
      >
        <Text>RED</Text>
      </View>
    ) : (
      <View style={{ ...cellStyle, flexBasis: "10%" }}>
        <Text>{duration}</Text>
      </View>
    )}
    <View style={{ ...cellStyle, flexBasis: "10%" }}>
      <Text> </Text>
    </View>
  </View>
);

const MINIMUM_ROW_COUNT = 16;

const TeamCardsDetails = ({ cards = {}, intl, players, teamName }) => {
  const allCards = Object.values(cards)
    .flat()
    .sort((c1, c2) => c1.minute - c2.minute);
  const cardData = [
    ...allCards,
    ...Array.from(Array(MINIMUM_ROW_COUNT - allCards.length)),
  ];
  return (
    <View style={{ marginTop: 10 }}>
      <Text style={{ fontSize: "12", fontWeight: "bold", textAlign: "center" }}>
        {teamName}
      </Text>
      <View
        style={{
          fontSize: 10,
          border: borderStyleGray,
          borderRight: "unset",
          borderBottom: "unset",
          marginTop: 6,
        }}
      >
        <TeamCardsHeader intl={intl} />
        {cardData.map((card, index) => (
          <CardDetailRow
            {...card}
            player={players[card?.personId]}
            intl={intl}
            key={index}
          />
        ))}
      </View>
    </View>
  );
};

export default TeamCardsDetails;
